import type { CMSColumnLinksDTO } from "~/features/cms/types/dto";
import { LinkList, LinkListItem } from "~/common/components/LinkList/LinkList";
import { resolveCMSIcon } from "./cmsIcons";

interface Props extends Omit<CMSColumnLinksDTO, "type"> {
  className?: string;
}

export const CMSColumnLinks = (props: Props) => {
  return (
    <LinkList
      title={props.headline}
      titleIcon={resolveCMSIcon(props.icon)}
    >
      {props.links.map((link, index) => (
        <LinkListItem
          key={index}
          linkType={link.urlType}
          href={link.url}
          headline={link.title}
          subheadline={link.subtitle}
        />
      ))}
    </LinkList>
  );
};
